import { autoinject } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { CustomerService as CommonCustomerService } from "@rightship-tech/common-ui/services/basic/customer-client.service";
import { FbrActivities } from "../../../../admin/activities/fbr-activity/fbr-activity";
import { PortsAndTerminalsService } from "../../services/ports-and-terminals.service";

@autoinject()
export class PortCallFbrsDialog {

    params: any;
    vesselImo: string;
    vesselName: string;

    constructor(public fbrActivities: FbrActivities, private dialogClientService: DialogClientService,
        private customerService: CommonCustomerService, private portsAndTerminalsService: PortsAndTerminalsService) {

    }

    activate(model: { vesselSKey: string, vesselImo: string, vesselName: string }) {
        this.portsAndTerminalsService.loadCachedBuSetting().then(bu => {
            if (!bu) {
                this.customerService.getBusinessUnitId().then(businessUnitId => {
                    this.setParams(model.vesselSKey, businessUnitId);
                });
            } else {
                this.setParams(model.vesselSKey, bu);
            }
        });

        this.vesselImo = model.vesselImo;
        this.vesselName = model.vesselName;
    }

    close() {
        this.dialogClientService.hide();
    }

    setParams(vesselSKey: string, buId: number) {
        this.params = {
            noDefaultFilters: true,
            vesselBKey: vesselSKey,
            businessUnitId: buId,
            isPortsAndTerminals: true,
            hideCounters: true
        };
    }
}